
export const scrollDetect = () => {
  let bodyEl = document.querySelector('body');
  let targetPos = 100;
  window.addEventListener('scroll',(e)=>{

    let condition = window.scrollY > targetPos;
    bodyEl.classList.toggle('scrolled',condition);

  })
};
